var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('register-sticker',{attrs:{"is-edit":true,"is-approved":_vm.isApproved,"is-duplicate":_vm.isDuplicate}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }